import React, { useState, useEffect } from 'react'
import { Button, Drawer, DrawerHeader, DrawerFooter, DrawerContent } from '@sainsburys-tech/bolt'
import Markdown from 'markdown-to-jsx'
import ServiceInformationDefaultMessage from './ServiceInformationDefaultMessage'
import ServiceInformationQuickViewContentSkeleton from './ServiceInformationQuickViewContentSkeleton'
import fetchServiceInformationContent from './helpers/fetchServiceInformationContent'
import trackInteraction from './helpers/analyticsHelper'

import * as Styled from './ServiceInformationQuickView.styles'

const ServiceInformationWrapper = props => <Styled.ServiceInformation {...props} />

const ServiceInformationHtmlContent = ({ content }) => {
  const contentAmend = content && content.replace(/^\s*\n/gm, '\r\n')

  return contentAmend ? (
    <Markdown options={{ wrapper: ServiceInformationWrapper, forceWrapper: true }}>{contentAmend}</Markdown>
  ) : (
    <ServiceInformationDefaultMessage />
  )
}

const ServiceInformationQuickViewContent = () => {
  const [{ content, isLoading }, setServiceInformationState] = useState({
    content: '',
    isLoading: true
  })

  useEffect(() => {
    fetchServiceInformationContent({ setServiceInformationState })
    trackInteraction()
  }, [])

  return isLoading ? (
    <ServiceInformationQuickViewContentSkeleton />
  ) : (
    <ServiceInformationHtmlContent content={content} />
  )
}

const ServiceInformationQuickView = ({ show, toggleCallback }) => {
  const ServiceInformationQuickViewFooter = () => (
    <Button onClick={toggleCallback} full kind='secondary' data-test='service-information-button'>
      Return to product
    </Button>
  )
  const drawerOptions = {
    position: 'right',
    show,
    onClose: toggleCallback,
    'data-test': 'service-information-drawer'
  }
  return (
    <Drawer {...drawerOptions}>
      <DrawerHeader>Installation & Recycling</DrawerHeader>
      <DrawerContent>
        <ServiceInformationQuickViewContent />
      </DrawerContent>
      <DrawerFooter>
        <ServiceInformationQuickViewFooter />
      </DrawerFooter>
    </Drawer>
  )
}

export default ServiceInformationQuickView
export { ServiceInformationHtmlContent, ServiceInformationQuickViewContent }
